import { Record } from 'immutable'

export default Record({
  key: '',
  type: null, // channels
  data: null, // Data Record
  searchToken: '',
  channelId: null,
})
